import { GenericError, IErrorDetails } from '@cian/peperrors/shared';
import { DOMAIN, ESubdomain, EErrorType } from '../constants/domain';

export class DeleteVacancyError extends GenericError {
  public constructor(configuration: { subdomain: ESubdomain; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      domain: `${DOMAIN}#${configuration.subdomain}`,
      type: EErrorType.DeleteVacancyError,
    });

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof NotFoundError
    Object.setPrototypeOf(this, DeleteVacancyError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DeleteVacancyError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
